import {
	NavigationTree,
	NavTreeItem,
} from '../../logic/domains/navigationTree.domain';
import { configuredRoutes } from '../Routing';
import _ from 'lodash';

export const injectAllConfiguredRoutes = (
	navigationTree: NavigationTree
): NavigationTree => {
	navigationTree.menuData = _(navigationTree.menuData)
		.map(navItem => injectConfiguredNavItem(navItem))
		.value();
	return navigationTree;
};

const injectConfiguredNavItem = (navigationItem: NavTreeItem): NavTreeItem => {
	const matchedNavItem = _.find(
		configuredRoutes,
		(configuredRoute: NavTreeItem) => {
			return configuredRoute.key === navigationItem.key;
		}
	);
	if (matchedNavItem) {
		navigationItem.path = matchedNavItem.path;
		navigationItem.title = matchedNavItem.title;
	}
	if (navigationItem.subpages) {
		navigationItem.subpages = _.map(navigationItem.subpages, childItem =>
			injectConfiguredNavItem(childItem)
		);
	}
	return navigationItem;
};
